/* eslint-disable camelcase */
import axios, { AxiosInstance } from 'axios';
import ENDPOINTS from '../constants/endpoints.constants';
import { generateUuid } from '../utils/uid.utils';
import { getIsDemoAccount, getIsDemoExperience } from './globalConfig.services';

interface LogData {
  session_id: string;
  shipment_pk: number;
  event_type: string;
  event_time: string;
  event_data: any;
}

class AgentService {
  private fetcher: AxiosInstance;

  private sessionId: string;

  private trackingId: number;

  private logQueue: Array<LogData> = [];

  constructor() {
    this.fetcher = axios.create({
      baseURL: `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api`,
      headers: {
        'x-session-id': this.sessionId,
      },
    });

    this.sessionId = generateUuid();
    setInterval(() => this.sendLog(), 5000);
  }

  init(trackingId: number) {
    this.trackingId = trackingId;
  }

  async tap(eventType: string, eventData: any) {
    // Gate before the queue, not at send: `sendLog` posts whatever the queue
    // holds. The host check below already silences a v2 demo on a PP host; the
    // gap it leaves is a demo served from anywhere else, which would otherwise
    // flush session and campaign events every five seconds.
    if (getIsDemoExperience()) return;

    const isPPHost = window.location.hostname.includes('parcelperform');

    if (isPPHost && !getIsDemoAccount()) return;

    const time = new Date();
    this.logQueue.push({
      session_id: this.sessionId,
      shipment_pk: this.trackingId,
      event_type: eventType,
      event_time: time.toISOString(),
      event_data: eventData,
    });
  }

  private async sendLog() {
    const chunk = this.logQueue.splice(0, 10);
    if (!chunk.length) {
      return;
    }
    try {
      await this.fetcher.post(`/v1/ptp/shipment-update/`, chunk);
    } catch (e) {
      //
    }
  }
}

export const agentService = new AgentService();
